import React from 'react';
import {connect} from 'react-redux';
import {AppBar, Box, Divider, IconButton, Toolbar, Tooltip, useMediaQuery, useTheme} from '@mui/material';
import {MenuRounded} from '@mui/icons-material';
import {styled} from '@mui/system';
import AccountPopover from './AccountPopover';
import ThemeSwitch from './ThemeSwitch';
import Notifications from '../notifications/Notifications';
import WorkspaceMultiSelect from '../workspace/WorkspaceMultiSelect';
import {sidebarCollapsedWidth, sidebarWidth} from './navigation';
import {sidebarActions} from '../../store/actions/sidebarAction';
import Logo from '../utils/Logo';

const CustomAppBar = styled(AppBar, {shouldForwardProp: prop => prop !== 'sidebarOffset'})(
    ({theme, sidebarOffset}) => ({
        zIndex: theme.zIndex.appBar,
        marginLeft: sidebarOffset,
        width: `calc(100% - ${sidebarOffset}px)`,
        transition: theme.transitions.create(['width', 'margin'], {duration: theme.transitions.duration.shorter})
    })
);

export function Topbar({sidebar, handleDrawerOpen}) {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const width = sidebar.isOpen ? sidebarWidth : sidebarCollapsedWidth;
    const offset = isDesktop ? width : 0;
    return (
        <CustomAppBar position="fixed" elevation={0} sidebarOffset={offset}>
            <Toolbar sx={{'&.MuiToolbar-root': {pl: {xs: 2, sm: 2, md: 0}, pr: '10px', minHeight: 48}, gap: 1}}>
                <Box sx={{flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 1}}>
                    {isDesktop ? <WorkspaceMultiSelect/> : <>
                        <Tooltip title="Open sidebar">
                            <IconButton
                                color="inherit"
                                edge="start"
                                aria-label="Open sidebar"
                                aria-expanded={sidebar.isOpenMobile}
                                aria-controls="app-sidebar"
                                onClick={handleDrawerOpen}
                            >
                                <MenuRounded/>
                            </IconButton>
                        </Tooltip>
                        <Logo width={50}/>
                    </>}
                </Box>
                <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
                    {!isDesktop && <WorkspaceMultiSelect compact/>}
                    <ThemeSwitch/>
                    <Notifications/>
                    <AccountPopover/>
                </Box>
            </Toolbar>
            <Divider/>
        </CustomAppBar>
    );
}

export default connect(state => ({sidebar: state.sidebar}), {handleDrawerOpen: sidebarActions.handleDrawerOpen})(Topbar);
